var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"clause"},[_vm._v(" 注册即代表同意 "),_c('a',{staticClass:"c494",attrs:{"href":"https://h5.kaoyanvip.cn/zt/userAgreement/"}},[_vm._v("《研途考研用户协议》")]),_vm._v("和"),_c('a',{staticClass:"c494",attrs:{"href":"https://h5.kaoyanvip.cn/zt/policy-2025/?type=1&level=4&source=m_station"}},[_vm._v("《隐私政策》")])])])
}]

export { render, staticRenderFns }